export default __webpack_public_path__ + "static/media/BBB.486032cb.png";